import AppView from '../../views/AppLayout'
/* import RequireAuth from '../auth' */
import DefaultRoutes from './default'

import MessagesRoutes from './messages'
import ContactsRoutes from './contacts'
import AgentDashboard from './agent-dashboard'
import AgentConsoleRoutes from './agent-console'
import ReportsRoutes from './reports'
import configurations from './configurations'
import admin from './admin'

const routes = [
  ...DefaultRoutes,
  ...AgentDashboard,
  ...ContactsRoutes,
  ...MessagesRoutes,
  ...AgentConsoleRoutes,
  ...ReportsRoutes,
  ...configurations,
  ...admin
]

export default [
  {
		path : '/',
		components : { 
			appView : AppView
		},
    children : routes,
    redirect: '/home'
	}
]